
import translate from 'google-translate-api-x';
import { TranslationResult } from "./types";
import { translationCache } from "./translationCache";
import { Log } from "../log";

// 文件级别log
const fileLog = new Log(false, 'translationService_file');
// fileLog.pause = true;

/**
 * 翻译文本
 */
async function translateText(
  text: string,
  sourceLang: string = 'auto',
  targetLang: string,
  isHtml: boolean = false
): Promise<TranslationResult> {
  const fnLog = fileLog.sub(false, 'translateText_fn');
  fnLog.pause = true;

  fnLog.log('translate text start', { text, sourceLang, targetLang, isHtml });

  // 检查缓存
  const cached = await translationCache.getFromCache(text, sourceLang, targetLang);

  if (cached) {
    fnLog.log('using cached translation', cached);
    return {
      text: cached.translatedText,
      from: cached.sourceLang,
      to: cached.targetLang,
    };
  } else {
    fnLog.log('cache miss, calling translation API');
  }

  try {
    // 调用翻译API
    const result = await translate(text, {
      from: sourceLang,
      to: targetLang,
      // google-translate-api-x 支持HTML翻译
      // 但需要检查具体版本是否支持format参数
    });

    fnLog.log('translation API result', result);

    const translatedText = result.text;
    const detectedSourceLang = result.from?.language?.iso || sourceLang;

    // 保存到缓存
    await translationCache.saveToCache(text, translatedText, detectedSourceLang, targetLang);

    fnLog.log('translation complete', { translatedText, detectedSourceLang, targetLang });

    return {
      text: translatedText,
      from: detectedSourceLang,
      to: targetLang,
    };
  } catch (error) {
    fnLog.error('translation failed', error);
    throw error;
  }
}

export const translationService = {
  translateText,
};
